import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: "form-link-block",
  type: "FormLinkBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Link",
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: "",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: false,
    },
  },
};
